import { decimal, money, shippingPercentage } from '@/js/shared/billables/decimal';

export function documentShippingAmount(subtotal, documentShipping) {
  switch (documentShipping?.method) {
    case 'flat':
      return money(documentShipping.amount);
    case 'percentage': {
      const shipping = subtotal
        .times(shippingPercentage(documentShipping.percentage))
        .div('100')
        .round(2);
      return shipping.lt('0') ? decimal(0) : shipping;
    }
    default:
      return null;
  }
}
